import { Helmet } from "react-helmet-async";

const SITE_URL = "https://dogaparquet.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({
    title,
    description,
    path = "/",
    image,
    type = "website",
    keywords,
    jsonLd,
    noIndex = false,
}) {
    const fullTitle = title
        ? `${title} — Dogaparquet`
        : "Dogaparquet — Posa Parquet e Decking a Modica (RG)";
    const url = `${SITE_URL}${path}`;
    const imageUrl = image || DEFAULT_IMAGE;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {noIndex && <meta name="robots" content="noindex, nofollow" />}
            <link rel="canonical" href={url} />

            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            {description && (
                <meta property="og:description" content={description} />
            )}
            <meta property="og:image" content={imageUrl} />
            <meta property="og:locale" content="it_IT" />
            <meta property="og:site_name" content="Dogaparquet" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && (
                <meta name="twitter:description" content={description} />
            )}
            <meta name="twitter:image" content={imageUrl} />

            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
}
